class Mensajes extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: false,
    };
  }

  handleHide() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap">
        <Modal
          show={this.state.showModal}
          container={this.props.container}
          onHide={this.handleHide}
          bsSize="medium"
          backdrop="static"
          aria-labelledby="contained-modal-title-sm"
        >
          <Modal.Header>
            <button
              id="close-modal"
              type="button"
              className="close-button"
              onClick={this.handleHide}
            >
              <i className="fa fa-times"></i>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="messages">
              {this.props.msg || "Discúlpenos, por favor intente más tarde"}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

/******************** BUILD ********************/
var Modal = ReactBootstrap.Modal;
/******************** BUILD ********************/

export default Mensajes;
